export enum LicenseMonthlySubscriptionSubFormEvents {
  CanBeManagedByAbove = 'canBeManagedByAbove',
}
